<template>
  <div class="bg-hex-$portalPrimaryBgColor h-full relative px-13px py-8px workplace-safety">
    <div class="absolute right-12px top-104/380">
      <div
        class="w-25px h-25px text-12px text-center !leading-25px text-hex-$portalPrimaryColor cursor-pointer border-1px border-$portalPrimaryColor rounded-1/2"
        @click="currentIndex = 1"
      >
        <span class="iconfont icon-line-up"></span>
      </div>
      <div
        class="w-25px h-25px text-12px text-center !leading-25px text-hex-$portalPrimaryColor mt-15px cursor-pointer border-1px border-$portalPrimaryColor rounded-1/2"
        @click="currentIndex = 11"
      >
        <span class="iconfont icon-line-down"></span>
      </div>
    </div>
    <div class="h-full overflow-hidden mr-35px">
      <div class="flex justify-between items-center h-20/380">
        <div class="flex-1 flex items-center truncate">
          <div class="text-14px">{{ pointList[0].name }}</div>
          <div class="text-hex-ff5c00 text-20px font-bold ml-7px mr-5px">
            {{ pointList[0].value }}
          </div>
          <div class="text-12px text-hex-999">{{ pointList[0].unit }}</div>
        </div>
        <div class="text-hex-$portalPrimaryColor text-14px font-bold">
          {{ currentIndex === 1 ? '运行数据' : '环保数据' }}
        </div>
      </div>
      <div class="dashed-border-red h-1px my-10px"></div>
      <div class="h-82/380 flex flex-col justify-around">
        <div class="flex text-center text-14px text-hex-333">
          <div class="w-125px truncate text-left">名称</div>
          <div class="flex-1 ml-5px truncate">一号机</div>
          <div class="flex-1 ml-5px truncate">二号机</div>
        </div>
        <div class="flex text-center text-14px text-hex-333">
          <div class="w-125px truncate text-left text-hex-999">
            {{ pointList[currentIndex].name }}({{ pointList[currentIndex].unit }})
          </div>
          <div class="flex-1 ml-5px truncate">{{ pointList[currentIndex].value }}</div>
          <div class="flex-1 ml-5px truncate">{{ pointList[currentIndex + 1].value }}</div>
        </div>
        <div class="flex text-center text-14px text-hex-333">
          <div class="w-125px truncate text-left text-hex-999">
            {{ pointList[currentIndex + 2].name }}({{ pointList[currentIndex + 2].unit }})
          </div>
          <div class="flex-1 ml-5px truncate">{{ pointList[currentIndex + 2].value }}</div>
          <div class="flex-1 ml-5px truncate">{{ pointList[currentIndex + 3].value }}</div>
        </div>
      </div>
      <div class="dashed-border h-1px mt-18px mb-18px"></div>
      <div class="h-192/380 flex flex-col justify-around">
        <div
          class="flex text-center text-14px text-hex-333 mb-10px"
          v-for="item in pointList.slice(currentIndex + 4, currentIndex + 10)"
          :key="item.name"
        >
          <div class="w-125px truncate text-left text-hex-999">
            {{ item.name }}({{ item.unit }})
          </div>
          <div class="flex-1 ml-5px truncate">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { compact, map, find } from 'lodash'
import axios from 'axios'
import pointConfig from '../js/workplaceSafetyConfig'

export default {
  data() {
    return {
      pointList: pointConfig,
      currentIndex: 1,
      timer: null,
    }
  },
  computed: {
    baseServer() {
      return Wiz.GetModuleServer('workbench')
    },
  },
  methods: {
    async getPointListByCode() {
      const codes = compact(
        map(this.pointList, (item) => {
          return `codes=${item.code}`
        })
      )
      axios({
        url: `${this.baseServer}/api/workbench/measuring-point/list-by-point-codes?${codes.join(
          '&'
        )}`,
        method: 'post',
        headers: {
          Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
        },
      }).then((res) => {
        if (res && res.status === 200 && !_.isEmpty(res.data)) {
          res.data.forEach((item) => {
            const point = find(this.pointList, { code: item.code })
            if (point) {
              point.pointId = `${item.pointId}`
            }
          })
          this.timer = setInterval(() => {
            this.getPointListRealTimeValue()
          }, 1000)
        }
      })
    },
    async getPointListRealTimeValue() {
      const pointIds = compact(
        map(this.pointList, (item) => {
          return item.pointId
        })
      )
      if (pointIds.length === 0) return
      axios({
        url: `${
          this.baseServer
        }/api/workbench/measuring-point/multiple-realtime-value?ids=${pointIds.join(',')}`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
        },
      }).then((res) => {
        if (res && res.status === 200 && !_.isEmpty(res.data?.data)) {
          res.data.data.forEach((item) => {
            if (item.values.length) {
              const point = find(this.pointList, { pointId: item.measuringPointId })
              if (point) {
                point.value = _.round(item.values[0].value, 2)
              }
            }
          })
        }
      })
    },
  },
  async created() {
    this.getPointListByCode()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
}
</script>

<style lang="scss" scoped>
.workplace-safety {
  .dashed-border {
    background: linear-gradient(
      to right,
      transparent 0%,
      transparent 50%,
      #e2e2e2 50%,
      #e2e2e2 100%
    );
    background-size: 20px 1px;
    background-repeat: repeat-x;
  }
  .dashed-border-red {
    background: linear-gradient(
      to right,
      transparent 0%,
      transparent 50%,
      var(--portalPrimaryColor) 50%,
      var(--portalPrimaryColor) 100%
    );
    background-size: 20px 1px;
    background-repeat: repeat-x;
  }
}
</style>
